/* Small progressive enhancements; no analytics, customer storage or network requests. */
(function () {
  'use strict';
  var stringsNode = document.getElementById('nhl-qa-strings');
  var strings = stringsNode ? JSON.parse(stringsNode.textContent) : {};
  var productForm = document.querySelector('form[data-build-handle]');
  if (productForm) {
    function handoff() {
      var choices = [];
      productForm.querySelectorAll('[data-cfg-group]').forEach(function (group) {
        var values = Array.from(group.querySelectorAll('input:checked:not(:disabled)')).map(function (i) { return i.value; });
        if (values.length) choices.push(group.getAttribute('data-cfg-group') + ': ' + values.join(', '));
      });
      var estimate = productForm.querySelector('[name="properties[Estimated total]"]');
      if (estimate) choices.push('Estimated total: ' + estimate.value);
      productForm.querySelectorAll('a[href*="preset="]').forEach(function (link) {
        var url = new URL(link.href); url.searchParams.set('configuration', choices.join('\n')); link.href = url.toString();
      });
    }
    productForm.addEventListener('change', handoff); handoff();
  }
  var amount = document.querySelector('[data-balance-amount]');
  if (amount) {
    var total = document.querySelector('[data-balance-total]');
    amount.addEventListener('input', function () {
      total.textContent = amount.validity.valid && amount.value ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(amount.value)) + ' USD' : '';
    });
  }
  var brief = document.querySelector('#commission-form textarea[name="contact[body]"]');
  if (!brief) brief = document.querySelector('#commission-form textarea:not([name="h-captcha-response"])');
  if (brief) {
    var params = new URLSearchParams(location.search), config = params.get('configuration'), ref = params.get('gallery_ref'), photo = params.get('gallery_image');
    var context = '';
    if (config && config.length <= 10000) context = config;
    if (ref && /^[a-zA-Z0-9_-]{1,160}$/.test(ref)) {
      context = 'Gallery reference: ' + ref;
      if (photo) { try { var u = new URL(photo, location.origin); if (u.protocol === 'https:' && (u.hostname === location.hostname || u.hostname === 'cdn.shopify.com')) context += '\nPhoto: ' + u.href; } catch (_) {} }
    }
    if (context) {
      brief.value = context + '\n\n' + brief.value;
      var note = document.createElement('p'); note.className = 'qa-handoff-note'; note.textContent = strings.handoff; brief.parentElement.before(note);
    }
  }
  // Shopify exposes the activator part. Move only the launcher, keeping the chat dialog native.
  var host, offset = 0, queued = false;
  function positionChat() {
    queued = false; host = document.querySelector('shopify-chat');
    var button = host && host.shadowRoot && host.shadowRoot.querySelector('[part="activator"]');
    if (!button) return;
    if (innerWidth > 980 || button.getAttribute('aria-expanded') === 'true') { offset = 0; host.style.setProperty('--nhl-chat-clearance', '0'); return; }
    var rect = button.getBoundingClientRect(), baseTop = rect.top + offset, baseBottom = rect.bottom + offset, next = 0;
    var targets = Array.from(document.querySelectorAll('main .btn, .pdp-stickybar:not([hidden]), .comm-sticky:not([hidden]), .sticky-cta.is-on'))
      .filter(function (el) { var r = el.getBoundingClientRect(); return r.width && r.height && r.top < innerHeight && r.bottom > 0; })
      .map(function (el) { return el.getBoundingClientRect(); });
    for (var pass = 0; pass < targets.length + 1; pass++) {
      var previous = next;
      targets.forEach(function (r) {
        if (rect.right > r.left && rect.left < r.right && baseBottom - next > r.top - 12 && baseTop - next < r.bottom + 12) next = Math.max(next, baseBottom - r.top + 12);
      });
      if (next === previous) break;
    }
    offset = Math.max(0, Math.min(next, baseTop - 110));
    host.style.setProperty('--nhl-chat-clearance', String(offset));
  }
  function schedule() { if (!queued) { queued = true; requestAnimationFrame(positionChat); } }
  addEventListener('scroll', schedule, { passive: true }); addEventListener('resize', schedule);
  document.addEventListener('click', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'aria-expanded'] });
  schedule();
  var attempts = 0, startup = setInterval(function () { schedule(); if (++attempts >= 20) clearInterval(startup); }, 500);
})();
